export const environment = {
  production: true,
  urlAPI: 'https://api-configurador.uecko.com/api/',
  blobPublic: 'https://blobueckomc.blob.core.windows.net/dev-uecko-public/'
};